// extracted by mini-css-extract-plugin
module.exports = {"edit-button":"phone_edit-button__2gBwF","input":"phone_input__lhGg8"};